import Button from "components/Button";
import Content from "components/Content";
import Label from "components/Label";
import Media from "components/Media";
import React, { FC } from "react";

import Image from "next/image";
import { useRouter } from "next/router";
import Mandala from "../../../../../public/pricing/pricing/mandala.png";
import Check from "../../../../../public/common/check.svg";

import { items } from "./constants";
import styles from "./styles.module.scss";

const Pricing: FC = () => {
  const router = useRouter();

  return (
    <Content contentClassName={styles.container}>
      <div className={styles.leftPanel}>
        <Label className={styles.title} variant="h" color="primary">
          $250/month
        </Label>
        <Label className={styles.subtitle} variant="s" color="primary">
          For no more “what about the air filters?” in the middle of the night.
        </Label>
        <Button
          onClick={() => router.push("/start")}
          className={styles.joinNow}
          variant="accent"
        >
          Join now
        </Button>
        <Label className={styles.disclaimer} variant="s" color="primary">
          *Your Humming Homes billing period begins at the time of payment.
          After your first month you will be charged $250 (plus applicable
          taxes) monthly until you cancel your membership. For homes over 6,000
          square ft, the monthly membership is $500 / mo.
        </Label>
        <Media className={styles.mandalaWrapper} at={["desktop"]}>
          <Image alt="" width={540} height={510} layout="fixed" src={Mandala} />
        </Media>
      </div>
      <div className={styles.rightPanel}>
        {items.map(({ title, content, link }) => (
          <div className={styles.item}>
            <Check className={styles.check} />
            <div className={styles.itemInfo}>
              <Label className={styles.itemTitle} variant="h" color="primary">
                {title}
              </Label>
              <Label className={styles.itemContent} variant="s" color="primary">
                {content}
              </Label>
              <Label
                className={styles.itemLink}
                linkColor="secondary"
                useMarkdown
              >{`[${link.label}](${link.to})`}</Label>
            </div>
          </div>
        ))}
      </div>
      <Media className={styles.mandalaWrapper} at={["tablet"]}>
        <Image alt="" width={468} height={442} layout="fixed" src={Mandala} />
      </Media>
      <Media className={styles.mandalaWrapper} at={["mobile"]}>
        <Image alt="" layout="responsive" src={Mandala} />
      </Media>
    </Content>
  );
};

export default Pricing;
